import { render, staticRenderFns } from "./LoginToken.vue?vue&type=template&id=c4046268&"
import script from "./LoginToken.vue?vue&type=script&lang=js&"
export * from "./LoginToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports